'use strict';

const generalFiltersPartsList = [
  "filters-sub-row",
  "filters-option-button",
  "filters-option-color-dot",
  "filters-option-text",
  "filters-option-icon-wrapper",
];
const extendedFiltersPartsList = [
  "extended-filters-button",
  "extended-filters-modal",
  "extended-filters-modal-wrapper",
  "extended-filters-header",
  "extended-filters-modal-close",
  "extended-filters-list",
  "extended-filters-row",
  "extended-filters-row-wrapper",
  "extended-filters-main-button",
  "extended-filters-selected-wrapper",
  "extended-filters-sub-list",
  "extended-filters-actions",
  "extended-filters-apply",
  "extended-filters-reset",
];
const filtersPartsList = [
  "filters-wrapper",
  "filters-list",
  "filters-main-button",
  "filters-footer",
  "filters-footer-list",
  "filters-sub-button",
];
const selectedFiltersPartsList = ["selected-filters-list"];
const histogramPartsList = [
  "histogram",
  "histogram-bar",
  "histogram-range-container",
  "histogram-sliders-control",
  "histogram-from-slider",
  "histogram-to-slider",
  "histogram-label-wrapper",
  "histogram-label",
];

const makeExportPartsString = (...args) => args.flat().join(", ");
const extendedFiltersParts = makeExportPartsString(extendedFiltersPartsList, histogramPartsList, generalFiltersPartsList);
const filtersParts = makeExportPartsString(filtersPartsList, histogramPartsList, generalFiltersPartsList);
makeExportPartsString(selectedFiltersPartsList, generalFiltersPartsList);
const priceRangeParts = makeExportPartsString(histogramPartsList);
const searchWidgetFilterParts = makeExportPartsString(extendedFiltersPartsList, filtersPartsList, histogramPartsList, generalFiltersPartsList);

exports.extendedFiltersParts = extendedFiltersParts;
exports.filtersParts = filtersParts;
exports.priceRangeParts = priceRangeParts;
exports.searchWidgetFilterParts = searchWidgetFilterParts;
